module.exports = __webpack_public_path__ + "static/media/applestore-badge.d0558d91.svg";